import React, {Component} from 'react';
import settings from '../../utils/settings';
import noImageAvailable from '../../styles/images/no-image-available.png';
import ReactTooltip from 'react-tooltip';
import {findDOMNode} from 'react-dom'
import GeoUtils from '../../utils/geoUtils';
import IPUtils from '../../utils/ipv4Utils';
import urlHandler from '../../utils/urlHandler';

class TextWithTooltip extends Component {
    constructor(props) {
        super(props);
        this.formatCSSClass = this.formatCSSClass.bind(this);
        this.renderContents = this.renderContents.bind(this);
        this.imageError = this.imageError.bind(this);

        this.uniqueId = 'id-' + Math.random().toString(36).substr(2, 16);
        this.bbcId = 'bbc-' + this.uniqueId;
        this.externalUrlsDisable = window._externalUrlsDisable;

    }

    formatCSSClass (entityType) {
        let parts = entityType.split(/[_\/]/);
        if (parts.length === 3 && parts[2].toLowerCase() === 'ticker') {
            return parts[2].toLowerCase();
        }
        return parts[0].toLowerCase();
    };

    imageError(e) {
        ReactTooltip.hide();
        this.setState({
            image: noImageAvailable
        })
    }

    renderContents() {

        const image = this.props.data.imageUrls ? this.props.data.imageUrls[0] : null;

        const baseballcard = this.props.data

        let sentiment_class = '';
        if (baseballcard && baseballcard.sentiment) {
            if (baseballcard.sentiment.class) {
                sentiment_class = 'bbc-sentiment-' + baseballcard.sentiment.class;
            }
        }

        
        if (baseballcard) {
            return(
                <div className="bbc" ref={this.bbcId}>
                    <div className="bbc-header">
                        <div className="bbc-label">{baseballcard.label} 
                            <span hidden={!baseballcard.orgInstanceOf} className="bbc-org-instance"> ({baseballcard.orgInstanceOf})</span>
                        </div>
                        {baseballcard.enclosingRegion &&
                            <div className="bbc-region">({baseballcard.enclosingRegion})</div>
                        }            
                    </div>
                    <div className="bbc-description">
                        {image && !this.externalUrlsDisable &&
                            <img src={image} onError={this.imageError}/>
                        }
                        <div>{baseballcard.description}</div>
                        <div className="bbc-extra">
                            {baseballcard.population &&
                                <div>Population: {baseballcard.population}</div>
                            }  
                            {baseballcard.coordinates &&
                                <div>Coordinates: {baseballcard.coordinates}</div>
                            }      
                            {baseballcard.orgStockExchange && baseballcard.orgStockTicker &&
                                <div>({baseballcard.orgStockTicker}) {baseballcard.orgStockExchange}</div>
                            }  
                            {baseballcard.moneyAmount &&
                                <div>Amount: {baseballcard.moneyAmount}</div>
                            }                  
                        </div>
                    </div>
                    {baseballcard.sentiment &&
                        <div className={sentiment_class}>
                            <div className="bbc-meta-entry">Sentiment Class: {baseballcard.sentiment.class}</div>
                            {(baseballcard.sentiment.score !== undefined) &&
                                <div className="bbc-meta-entry">Sentiment Score: {baseballcard.sentiment.score.toFixed(4)}</div>
                            }
                            {baseballcard.sentiment.classConfidence &&
                                <div className="bbc-meta-entry">Sentiment Confidence: {baseballcard.sentiment.classConfidence.toFixed(4)}</div>
                            }
                            {('topic' in baseballcard.sentiment) &&
                                <div className="bbc-meta-entry">Topic: {baseballcard.sentiment.topic}</div>
                            }
                        </div>
                    }
                    <div className="bbc-meta">
                        <div className="bbc-meta-entry-wrapper">
                            {baseballcard.extractionConfidence &&
                                <span className="bbc-meta-entry">
                                    <div>Extraction Confidence: {baseballcard.extractionConfidence.toFixed(4)}</div>
                                </span>
                            }
                            {baseballcard.finchId &&
                                <span className="bbc-meta-entry">
                                    <div>Finch Id: {baseballcard.finchId}</div>
                                </span>
                            }
                            {baseballcard.score &&
                                <span className="bbc-meta-entry">
                                    <div>Disambiguation Score: {baseballcard.score.toFixed(4)}</div>
                                </span>
                            }
                            {baseballcard.permIds &&
                                <span className="bbc-meta-entry">
                                    <div>Perm Id:&nbsp; 
                                        {baseballcard.permIds.map(function(permid, idx) {
                                            return <span key={idx}>{permid}<br/></span>
                                        })} 
                                    </div>
                                </span>
                            }
                            {baseballcard.spgId &&
                                <span className="bbc-meta-entry">
                                    <div>S&amp;P Global Id: {baseballcard.spgId}</div>
                                </span>
                            }
                            {('salienceScore' in baseballcard && baseballcard.salienceScore != null) &&
                                <span className="bbc-meta-entry">
                                    <div>Salience Score: {baseballcard.salienceScore.toFixed(4)}</div>
                                </span>
                            }
                        </div>
                    </div>
                </div>
            )
        } else {
            return (<div></div>);
        }
    }

    render() {
        const {data} = this.props;

        // const type_array = settings.getValue('types',[]).map((type) => type.name.toLowerCase());

        // const entities = segment.entities || [];
        // const hasEntities = (entities.length > 0);

        // const entityType = hasEntities ? entities[0].type.toLowerCase() : '';
        // const cssClassName = hasEntities ? this.formatCSSClass(type_array.includes(entityType) ? entityType : 'OTHER') : 'untagged';

        
        return(
            <div className={ 'tagged-with' }>
                
                <div
                    style={{cursor:'pointer', whiteSpace: 'pre-wrap', fontSize:'15px'}}
                    data-tip 
                    data-for={this.uniqueId}  
                    ref={this.uniqueId}>
                    <span className='fa fa-id-card' style={{color:'#00a2ae'}}>&nbsp;&nbsp;</span> 
                    {data.label}
                </div>                
                <ReactTooltip id={this.uniqueId} 
                        type='dark' 
                        effect='solid' 
                        place='left'
                        delayShow={500} 
                        delayHide={200}
                        delayUpdate={200}
                        class='bbc-base'>
                    { this.renderContents() }
                </ReactTooltip>
            </div>
        )
    }
}

export default TextWithTooltip;